import {
  Panel,
  SPACING_32,
  SPACING_40,
  SpacingVertical,
  Title,
  TITLE_VARIANT_M
} from 'mailup-web-components'

import { useIntl } from 'react-intl'
import BoxSelectRecipientsConditions from './BoxSelectRecipientsConditions'
import BoxSelectRecipientsGroupsAndFilters from './BoxSelectRecipientsGroupsAndFilters'

const BoxSelectRecipients = () => {
  const intl = useIntl()
  return (
    <>
      <Panel>
        <Title variant={TITLE_VARIANT_M}>
          {intl.formatMessage({ id: 'Load.Task.ConditionsTitle' })} *
        </Title>
        <SpacingVertical variant={SPACING_32} />
        <BoxSelectRecipientsGroupsAndFilters />
        <SpacingVertical variant={SPACING_40} />
        <BoxSelectRecipientsConditions />
      </Panel>
    </>
  )
}

export default BoxSelectRecipients
